var render = function render(){var _vm=this,_c=_vm._self._c;return _c('contratos',{attrs:{"dataServicos":_vm.obterDataServicos(),"rotaDetalhar":"Gescon_Gerentes_Contratos_Detalhar","rotaListagem":"Gescon_Gerentes_Contratos","permiteDetalhar":_vm.$temAcessoView('GESCON-GER-CONT-00')}})
}
var staticRenderFns = []

export { render, staticRenderFns }